import dynamic from "next/dynamic";
import FixedLoader from 'components/FixedLoader';

const AllContributionsModal = dynamic(() => import("./Content"), {
  ssr: false,
  loading: () => <FixedLoader />,
});

export default AllContributionsModal;